var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHypermaxSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "HyperMaxLogoMobile",
    width: 95,
    height: 100,
    viewBox: "0 0 95 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "css-1oteowz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_54111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7734 63.7433C62.545 66.8157 87.2945 57.9891 93.6163 35.5228C94.5655 32.1493 95.0003 28.6535 95.0003 25.1482V1.60443C95.0003 0.701068 94.2709 -0.00468161 93.3731 2.33878e-05H63.9525C63.0547 2.33878e-05 62.3299 0.734003 62.3299 1.63266V24.4801C62.3299 59.3583 39.7734 63.7386 39.7734 63.7386V63.7433Z",
    fill: "#6EA642"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62253 0H31.1414C32.0392 0 32.7639 0.729275 32.7639 1.63263V30.9824C19.952 32.0693 7.72924 37.066 0 46.2642V1.63263C0 0.729275 0.724763 0 1.62253 0Z",
    fill: "#006BA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3777 99.9998H63.8589C62.9611 99.9998 62.2363 99.2705 62.2363 98.3671V69.0174C75.0529 67.9352 87.2757 62.9385 95.0049 53.7402V98.3671C95.0049 99.2705 94.2802 99.9998 93.3824 99.9998H93.3777Z",
    fill: "#006BA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3299 1.63263V24.4801C62.3299 59.3582 39.7734 63.7386 39.7734 63.7386C39.9605 63.7621 40.1522 63.7809 40.3392 63.8045C57.2753 61.6072 72.4719 52.4278 77.2273 35.518C78.1765 32.1445 78.6114 28.6487 78.6114 25.1435V0H63.9478C63.05 0 62.3252 0.73398 62.3252 1.63263H62.3299Z",
    fill: "#006BA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2269 36.2612C32.4553 33.1888 7.70586 42.0154 1.38406 64.4818C0.434858 67.8506 0 71.3511 0 74.8563V98.3954C0 99.2987 0.729438 100.004 1.62721 99.9998H31.0479C31.9457 99.9998 32.6704 99.2658 32.6704 98.3672V75.5197C32.6704 40.6416 55.2269 36.2612 55.2269 36.2612Z",
    fill: "#006BA6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6662 98.3671V75.5197C32.6662 40.6415 55.2227 36.2612 55.2227 36.2612C55.0356 36.2377 54.8439 36.2188 54.6569 36.1953C37.7208 38.3925 22.5242 47.572 17.7688 64.4818C16.8196 67.8552 16.3848 71.3511 16.3848 74.8563V100.004H31.0483C31.9461 100.004 32.6709 99.2705 32.6709 98.3718L32.6662 98.3671Z",
    fill: "#6EA642"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_54111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypermaxSmallLogo);
export default __webpack_public_path__ + "static/media/hypermax-small-logo.a0e1699f4f17633d149f88d9d57704cf.svg";
export { ForwardRef as ReactComponent };